<!--
 * @Author: zl
 * @Date: 2022-03-29 08:53:38
 * @LastEditTime: 2022-12-16 10:56:54
 * @LastEditors: zl
 * @Description: 项目投资管理
-->
<template>
	<div class="InvestmentIndex-layout filter-layout">
		<div class="filter-box pdt10">
			<el-form ref="searchForm"
					 :model="searchForm"
					 size="small"
					 label-width="100px">
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item label="片区"
									  prop="area"
									  label-width="90px">
							<div class="custom-box">
								<span :key="item.id"
									  v-for="item in typeList('xmgsqy')"
									  :class="{ 'active-span': searchForm.area.join(',') == item.value }"
									  @click="searchClick(item, 'area')">
									<TextTooltip :refName="item.value + 'area'"
												 :content="item.sname"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="计划编排类别"
									  prop="start">
							<div class="custom-box">
								<span :key="item.id"
									  v-for="item in typeOptions"
									  :class="{ 'active-span': searchForm.start == item.value }"
									  @click="searchClick(item, 'start')">
									<TextTooltip :refName="item.value + 'start'"
												 :content="item.label"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="进展状况"
									  prop="stateDescribe">
							<div class="custom-box">
								<span :key="item.id"
									  v-for="item in stateOptions"
									  :class="{ 'active-span': searchForm.stateDescribe == item.value }"
									  @click="searchClick(item, 'stateDescribe')">
									<TextTooltip :refName="item.value + 'stateDescribe'"
												 :content="item.label"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item label="建设类型"
									  prop="constType"
									  label-width="90px">
							<div class="custom-box sp-box">
								<span :key="item.id"
									  class="text-overflow"
									  v-for="item in typeList('dxjslx')"
									  :class="{ 'active-span': searchForm.constType.join(',') == item.value }"
									  @click="searchClick(item, 'constType')">
									<TextTooltip :refName="item.value + 'constType'"
												 :content="item.sname"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="时间维度"
									  prop="selectDateType">
							<div class="custom-box time-box">
								<span :key="item.id"
									  class="text-overflow"
									  v-for="item in timeOptions"
									  :class="{ 'active-time': searchForm.selectDateType == item.value, 'disabled': item.disabled }"
									  @click="searchClick(item, 'selectDateType')">
									<TextTooltip :refName="item.value + 'selectDateType'"
												 :content="item.label"></TextTooltip>
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="选择时间"
									  prop="time">
							<el-date-picker type="daterange"
											v-model="searchForm.time"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											range-separator="~"
											clearable
											disabled
											@change="timeChange"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item label="项目名称"
									  prop="sname"
									  label-width="90px">
							<el-input v-model="searchForm.sname"
									  placeholder="请输入项目名称"
									  clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="项目类型"
									  prop="newProType">
							<el-select v-model="searchForm.newProType"
									   placeholder="请选择表单类型"
									   clearable>
								<el-option v-for="item in projectDict.dxxmlx"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>

						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="建设单位"
									  prop="constructionUnit">
							<el-select v-model="searchForm.constructionUnit"
									   placeholder="请选择建设单位"
									   clearable>
								<el-option v-for="(item, index) in constructionUnitList"
										   :key="index"
										   :label="item.sname"
										   :value="item.ownerUnit"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item class="text-right"
									  label-width="0">
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="submitForm">查询</el-button>
							<el-button @click="resetForm"
									   icon="el-icon-refresh">重置</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="filter-content primary-layout">
			<h3 class="text-center pdt10 pdb10">东部新中心建设项目投资统计报表</h3>
			<div class="primary-header">
				<div class="left-text">
					筛选时间统计: {{ tableObj.rangeTime }}
					<!-- <span class="tips">
						<i class="el-icon-warning"></i>
						统计期内{{ showMsg }}项目数： {{ tableObj.total }}个
					</span> -->
				</div>
				<div class="btnGroups">
					单位： <el-radio-group v-model="searchForm.type"
									size="mini"
									class="mr10"
									@change="getInvestmentData">
						<el-radio-button label="0">元</el-radio-button>
						<el-radio-button label="1">万元</el-radio-button>
					</el-radio-group>
					<el-button type="primary"
							   size="mini"
							   icon="el-icon-menu"
							   @click="doFilter">列过滤</el-button>
					<el-button size="mini">导出Excel</el-button>
				</div>
			</div>
			<div class="primary-content">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="tableObj.data"
								   highlight-hover-row
								   highlight-current-row
								   height="100%"
								   :loading="tableObj.loading"
								   ref="investTable"
								   show-header-overflow="tooltip"
								   show-overflow="tooltip">
							<vxe-column title="序号"
										type="seq"
										width="65"></vxe-column>
							<vxe-column title="项目名称"
										field="projectName"
										header-align="center"
										align="left"
										min-width="150">
								<template #default="{ row }">
									<span class="vxe-cell--label blue-text">
										{{ row.projectName }}
									</span>
								</template>
							</vxe-column>
							<vxe-column title="片区"
										field="isNorthName"
										width="100"></vxe-column>
							<vxe-column title="建设单位"
										field="constructionUnitName"
										min-width="150"
										header-align="center"
										align="left">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.constructionUnitName"
												placement="top">
										<span class="vxe-cell--label">{{ row.constructionUnitShortName }}</span>
									</el-tooltip>
								</template>
							</vxe-column>
							<vxe-column title="计划编排类别"
										field="planningCategory"
										width="120"></vxe-column>
							<vxe-column title="项目类型"
										field="proTypeName"
										width="120px"></vxe-column>
							<vxe-column title="建设类型"
										field="constructionTypeName"
										width="120px"></vxe-column>
							<vxe-column title="争取开工年份"
										field="striveStartDate"
										width="120px"></vxe-column>
							<vxe-column title="进展状况"
										field="constType"
										width="120px"></vxe-column>
							<vxe-column title="项目总投资"
										field="proTotalValue"
										header-align="center"
										align="right"
										width="120"></vxe-column>
							<vxe-column title="本月计划完成投资"
										field="completedOutputValue"
										header-align="center"
										align="right"
										width="140"></vxe-column>
							<vxe-column title="本月审核完成投资"
										field="peroidOutputValue"
										header-align="center"
										align="right"
										width="140"></vxe-column>
							<vxe-column title="本月实际付款"
										field="examineOutputValue"
										header-align="center"
										align="right"
										width="140"></vxe-column>
							<vxe-colgroup title="累计完成"
										  header-class-name="custom-table-height">
								<vxe-column title="累计审核完成投资"
											field="totalPeroidOutputValue"
											header-align="center"
											align="right"
											width="160"
											header-class-name="custom-table-height">
									<template slot="header">
										累计审核完成投资
										<el-tooltip effect="light"
													content="累计完成比例=累计审核完成投资/项目总投资x100%"
													placement="top">
											<svg-icon icon-class="wenhao"></svg-icon>
										</el-tooltip>
									</template>
								</vxe-column>
								<vxe-column title="累计完成比例"
											field="totalOutputValueRatio"
											header-align="center"
											align="right"
											width="120"
											header-class-name="custom-table-height"></vxe-column>
							</vxe-colgroup>
							<vxe-colgroup title="累计付款"
										  header-class-name="custom-table-height">
								<vxe-column title="累计付款"
											field="totalExamineOutputValue"
											header-align="center"
											align="right"
											width="120"
											header-class-name="custom-table-height">
									<template slot="header">
										累计付款
										<el-tooltip effect="light"
													content="累计付款比例=累计付款/项目总投资x100%"
													placement="top">
											<svg-icon icon-class="wenhao"></svg-icon>
										</el-tooltip>
									</template>
								</vxe-column>
								<vxe-column title="累计付款比例"
											field="totalValueRatio"
											header-align="center"
											align="right"
											width="120"
											header-class-name="custom-table-height"></vxe-column>
							</vxe-colgroup>
							<vxe-column title="操作"
										width="150">
								<template #default="{ row }">
									<el-button type="primary"
											   round
											   plain
											   class="table-btn"
											   @click="enterProject(row)">
										<svg-icon icon-class="form-enter"></svg-icon> 进入项目
									</el-button>
								</template>
							</vxe-column>
						</vxe-table>
					</div>
					<div class="w-table-pager">
						<vxe-pager :current-page="tableObj.currentPage"
								   :page-size="tableObj.pageSize"
								   :total="tableObj.total"
								   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
								   align="center"
								   @page-change="handleCurrentChange"></vxe-pager>
					</div>
				</div>
			</div>
		</div>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getContainerParams } from '@/api/home/homeIndex'
import * as ProjectApi from 'api/projectManage/ProjectIndex'
import * as API from 'api/Investment/InvestmentIndex'
import ColumnFilter from '@/views/Common/ColumnFilter'
import TextTooltip from '@/views/Common/TextTooltip'
export default {
	name: 'InvestmentIndex',
	components: { ColumnFilter, TextTooltip },
	data() {
		return {
			searchForm: {
				selectDateType: 2,
				time: [],
				startDate: '',
				sname: '', //项目名称
				area: [],
				constructionUnit: '', //建设单位
				start: '0', //0 新建项目、1 开展前期、2 续建项目
				type: '1', //0 元、1 万元
				newProType: '', //项目类型
				stateDescribe: 'all', //进展状态
				constType: '', //建设类型
			},
			tableObj: {
				rangeTime: '',
				loading: false,
				data: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			constructionUnitList: [], //建设单位列表
			isNorth: true,
			showFilter: false,
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
		}
	},
	created() {
		this.searchForm.area = this.projectDict.xmgsqy.map((x) => x.value)
		this.searchForm.constType = this.projectDict.dxjslx.map((x) => x.value)
		// 获取当前时间
		this.getContainerParams()
		// 根据单位类型查询单位
		this.getCompanyList()
		setTimeout(() => {
			let tableColumn = this.$refs.investTable.getTableColumn()
			tableColumn.fullColumn.shift()
			tableColumn.fullColumn.pop()
			this.filterColumns[0].columns = tableColumn.fullColumn
		}, 1500)
	},
	methods: {
		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			this.tableObj.loading = true
			if (this.$refs.investTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.$refs.investTable.refreshColumn()
				this.tableObj.loading = false
				return
			}
			this.tableObj.loading = false
		},

		// 获取当前时间
		getContainerParams() {
			getContainerParams({}).then((res) => {
				let now = res.data.currentDate
				let start = this.$utils.getWhatMonth(now, 0, 'first')
				let end = this.$utils.getWhatMonth(now, 0, 'last')
				start = this.$utils.toDateString(start, 'yyyy-MM-dd')
				end = this.$utils.toDateString(end, 'yyyy-MM-dd')
				this.searchForm.startDate = res.data.currentDate
				this.searchForm.endDate = end
				this.tableObj.rangeTime = start + ' 至 ' + end
				this.searchForm.time = [start, end]
				this.getInvestmentData()
			})
		},

		// search 区域点击事件
		searchClick(data, type) {
			if (type == 'selectDateType') {
				return
			}
			if (type == 'area') {
				this.searchForm[type] = []
				if (Array.isArray(data.value)) {
					this.searchForm[type] = data.value
				} else {
					this.searchForm[type].push(data.value)
				}
				this.getInvestmentData()
				return
			}
			this.searchForm[type] = data.value
			this.getInvestmentData()
		},

		// 根据单位类型查询单位
		getCompanyList() {
			ProjectApi.selectSysTenantsByType().then((res) => {
				this.$set(this, 'constructionUnitList', res.data.SUBJECT_JSDW)
			})
		},

		// 获取形象进度列表数据
		getInvestmentData() {
			let params = this.$utils.clone(this.searchForm, true)
			delete params.time
			params.area = params.area.join(',')
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			this.tableObj.loading = true
			API.getInvestmentManagePage(params)
				.then((res) => {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 选择时间 change 事件
		timeChange(data) {
			if (!data) {
				this.searchForm.startDate = ''
				this.searchForm.endDate = ''
				this.tableObj.rangeTime = ''
				return
			}
			this.searchForm.startDate = data[0]
			this.tableObj.rangeTime = data[0] + ' 至 ' + data[1]
		},

		// 合计 change
		checkBoxChange(data) {
			this.searchForm.area = !data
				? []
				: this.projectDict.xmgsqy.map((x) => x.value)
		},

		// 表单搜索
		submitForm() {
			this.tableObj.currentPage = 1
			this.getInvestmentData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.tableObj.currentPage = 1
			this.getContainerParams()
		},

		// 分页处理
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
			this.tableObj.pageSize = pageSize
			this.getInvestmentData()
		},

		// 进入项目
		enterProject(data) {
			let url = this.$outUrl
			let token = this.$getSessionItem('token')
			let tenantId = this.$getSessionItem('tenantId')
			let limitId = this.$getSessionItem('limitId')
			ProjectApi.getAuditWorkPower({
				projectId: data.projectId,
			}).then((res) => {
				if (res.operationCode == 1 && res.msg == 'faild') {
					this.$message.warning(res.data)
					return
				}
				window.open(
					`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
					'_blank'
				)
			})
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		// 时间维度
		timeOptions() {
			let arr = [
				{
					label: '昨日',
					disabled: true,
					value: 0,
				},
				{
					label: '今日',
					disabled: true,
					value: 1,
				},
				{
					label: '本月',
					disabled: false,
					value: 2,
				},
				{
					label: '本季度',
					disabled: true,
					value: 3,
				},
				{
					label: '本年',
					disabled: true,
					value: 4,
				},
			]
			return arr
		},

		// 计划编排类别
		typeOptions() {
			let arr = [
				{
					label: '全部',
					value: '0',
					id: '100085',
				},
				{
					label: '新建项目',
					value: '1',
					id: '100086',
				},
				{
					label: '开展前期',
					value: '2',
					id: '100087',
				},
				{
					label: '续建项目',
					value: '3',
					id: '100088',
				},
			]
			return arr
		},

		// 进展状况
		stateOptions() {
			let arr = [
				{
					label: '全部',
					value: 'all',
					id: '10001',
				},
				{
					label: '未开工',
					value: '0',
					id: '10002',
				},
				{
					label: '已开工',
					value: '1',
					id: '10003',
				},
				{
					label: '竣工',
					value: '2',
					id: '10004',
				},
			]
			return arr
		},

		// list
		typeList() {
			return function (type) {
				let arr = this.$utils.clone(this.projectDict[type], true)
				let obj = {
					sname: '全部',
					value: '',
				}
				if (arr) {
					obj.value = arr.map((x) => x.value)
					arr.unshift(obj)
				}
				return arr
			}
		},

		// 提示信息
		showMsg() {
			let area = this.areaOptions.find(
				(x) => x.value == this.searchForm.area
			)
			let type = this.typeOptions.find(
				(x) => x.value == this.searchForm.start
			)
			let progress = this.stateOptions.find(
				(x) => x.value == this.searchForm.stateDescribe
			)
			return area.sname + type.label + progress.label
		},
	},
	watch: {
		'searchForm.area': {
			handler(val, oldval) {
				this.isNorth = val.length == 3 ? true : false
			},
			deep: true,
		},
	},
}
</script>
<style lang='less' scoped>
.InvestmentIndex-layout {
	height: 100%;
	.el-checkbox {
		margin-right: 15px;
	}
	.tips {
		color: #e6a23c;
		font-size: 16px;
		margin-left: 30px;
	}
	.custom-box {
		display: flex;
		span + span {
			margin-left: 10px;
		}
		span:hover {
			background-color: #2cbdfc;
			color: #fff;
		}
	}
	.custom-box > * {
		flex: 1;
		text-align: center;
		height: 28px !important;
		line-height: 30px !important;
		font-size: 12px;
		background-color: #f2f2f2;
		color: #868686;
		cursor: pointer;
	}
	.sp-box > * {
		flex: inherit;
		padding: 0 13px;
	}
	.sp-box span:first-child {
		padding: 0 15px !important;
	}
	.active-span {
		background-color: #2cbdfc !important;
		color: #fff !important;
	}
	.time-box > * {
		height: 32px !important;
		line-height: 32px !important;
	}
	.time-box {
		span {
			border: 1px solid #eee;
			background-color: #fff;
			color: #333;
		}
		span + span {
			margin-left: 0px !important;
		}
		.active-time {
			background-color: #2cbdfc !important;
			color: #fff !important;
			border: 1px solid #2cbdfc !important;
		}
		span:first-child {
			border-top-left-radius: 3px;
			border-bottom-left-radius: 3px;
		}
		span:last-child {
			border-top-right-radius: 3px;
			border-bottom-right-radius: 3px;
		}
		.disabled {
			cursor: not-allowed !important;
			background-color: #fafafa;
			color: #868686;
		}
		.disabled:hover {
			border: 1px solid #eee;
			background-color: #fafafa;
			color: #868686;
		}
	}
}
</style>